import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { actions } from '../../constants/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewInvoiceButton = ({
  invoiceLink,
  onClickButton
}) => {
  return /*#__PURE__*/_jsx(Link, {
    onClick: () => {
      onClickButton(actions.VIEW);
    },
    "data-test-id": "view-btn",
    external: true,
    href: invoiceLink,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.components.invoiceActionsDropdown.buttons.view"
    })
  }, "view-btn");
};
export default ViewInvoiceButton;